import get from "lodash/get";

export const getFilterGraphs = state => Object.values(get(state, "admin.resources.filterGraphs.data", {}));
